import React from "react";

const CurrentPlayerDisplay = ({ player }) => {
	if (!player) return null;
	return (
		<div className="flex flex-col items-center bg-white p-4 px-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h2 className="text-lg font-bold">Au tour de: {player.pseudo}!</h2>
		</div>
	);
};

export default CurrentPlayerDisplay;
